<template>
    <div class="shadow" v-if="isShow">
        <div class="container">
            <div class="message">{{ $compLanguage.message }}</div>
            <div class="g-flex g-ai-c">
                <p class="btn_close" @click="handleClose">{{ $compLanguage.closeBtnText }}</p>
                <p class="btn_finshed" @click="handleClose">{{ $compLanguage.endBtnText }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'confirmPayment',
    props: {
        baseInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data () {
        return {
            isShow: false
        }
    },
    computed: {
        $compLanguage () {
            return this.$language.component.confirmPayment
        }
    },
    methods: {
        // 关闭/支付完成
        handleClose () {
            this.handleWebTransactionResult()
        },
        // 同步支付结果给到客户端
        handleWebTransactionResult () {
            let params = { orderId: this.baseInfo.orderId }
            this.$apis.checkOrderStatus(params).then(res => {
                if (res.code === '2000') {
                    let result = false
                    if (res.data.payStatus === 2 || res.data.payStatus === '2') result = true
                    $jsBridge.call('web_transactionResult', { result })
                }
                $jsBridge.call('web_closeWindow')
            }).catch(err => {
                console.log(err)
                $jsBridge.call('web_closeWindow')
            })
        }
    }
}
</script>

<style lang="less" scoped>
.shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    .container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 270px;
        height: 155px;
        background: #FFFFFF;
        border-radius: 10px;
        overflow: hidden;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #333333;
    }
    .message {
        width: 100%;
        height: 99px;
        line-height: 114px;
        text-align: center;
        border-bottom: .5px solid #AAAAAA;
    }
    .btn_close, .btn_finshed {
        width: 49.9%;
        line-height: 30px;
        text-align: center;
    }
    .btn_close {
        color: #999999;
        border-right: 1px solid #CCCCCC;
    }
}
</style>
